import { useEffect, useRef } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useMRN } from '../../context/MRNContext';
import { useAuth } from '../../context/AuthContext';

export default function AccessPage() {
    const { accessCode } = useParams();   // route must be /a/:accessCode
    const navigate = useNavigate();
    const { setMrn } = useMRN();
    const { initializeAuth } = useAuth();
    const hasRun = useRef(false);

    async function exchange() {
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/functions/v1/exchange-token`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "x-admin-secret": process.env.REACT_APP_ADMIN_SECRET,
                    },
                    body: JSON.stringify({ token: accessCode })
                }
            );

            if (!res.ok) throw new Error("invalid");

            // 2. Match the response key from your Deno return: { accessToken: accessToken }
            const { patient_id, access_token } = await res.json();

            sessionStorage.setItem('access_token', access_token); // Store access token in session storage

            setMrn(patient_id);
            // 2. Tell AuthContext to look at sessionStorage right now
            await initializeAuth();
            navigate("/welcome");
        } catch {
            navigate("/invalid-link");
        }
    }

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        exchange();
    });

    return <p>Logging you in...</p>;
}